<template>
  <div id="hydwbgsh">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'hydwbgsh'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/member/approve/companyBg/Hydwbgsh.vue